import React from 'react'
import { useNavigate } from 'react-router'
import useIsMobile from '../../hooks/useIsMobile'
import Social from '../Social'
// import { Link } from 'react-router-dom'
import { PoolsIcon } from '../../svgIcons/PoolsIcon'
import { LeaderboardIcon } from '../../svgIcons/LeadrboardIcon'
import { ChartsIcon } from '../../svgIcons/ChartsIcon'
import { SwapHorizontalIcon } from '../../svgIcons/SwapHorizontalIcon'
import StarknetLogo from '../../images/icons/starknetLogo.png'

function Footer(props: { selectedTab: string; className?: string; isSocialDisabled?: boolean }) {
    const { selectedTab, className, isSocialDisabled = false } = props
    const isMobile = useIsMobile()
    const navigate = useNavigate()

    function renderNavigation() {
        return (
            <>
                <span
                    onClick={() => navigate('/swap')}
                    className={`px-3 h-[60px] justify-center flex items-center flex-col text-[12px] border-t-[4px] cursor-pointer px-2 py-1 ${
                        selectedTab === 'swap' ? 'border-[#0AE8F9] text-[#0AE8F9] font-500' : 'border-[transparent] text-white font-500'
                    }`}>
                    <SwapHorizontalIcon className='w-[20px] h-[20px] mb-1' />
                    <span>Swap</span>
                </span>
                <span
                    onClick={() => navigate('/positions')}
                    className={`px-3 h-[60px] justify-center flex items-center flex-col text-[12px] border-t-[4px] cursor-pointer px-2 py-1 ${
                        selectedTab === 'pools' ? 'border-[#0AE8F9] text-[#0AE8F9] font-500' : 'border-[transparent] text-white font-500'
                    }`}>
                    <PoolsIcon className='w-[20px] h-[20px] mb-1' />
                    <span>Pools</span>
                </span>
                <span
                    onClick={() => navigate('/leaderboard')}
                    className={`px-3 h-[60px] justify-center flex items-center flex-col text-[12px] border-t-[4px] cursor-pointer px-2 py-1 ${
                        selectedTab === 'leaderboard' ? 'border-[#0AE8F9] text-[#0AE8F9] font-500' : 'border-[transparent] text-white font-500'
                    }`}>
                    <LeaderboardIcon className='w-[20px] h-[20px] mb-1' />
                    <span>Leaderboard</span>
                </span>
                <span
                    onClick={() => navigate('/charts')}
                    className={`px-3 h-[60px] justify-center flex items-center flex-col text-[12px] border-t-[4px] cursor-pointer px-2 py-1 ${
                        selectedTab === 'charts' ? 'border-[#0AE8F9] text-[#0AE8F9] font-500' : 'border-[transparent] text-white font-500'
                    }`}>
                    {' '}
                    <ChartsIcon className='w-[20px] h-[20px] mb-1' />
                    <span>Charts</span>
                </span>
                <span
                    onClick={() => navigate('/rewards')}
                    className={`px-3 h-[60px] justify-center flex items-center flex-col text-[12px] cursor-pointer px-2 py-1 border-t-[4px]  ${
                        selectedTab === 'rewards' ? 'border-[#0AE8F9] text-[#0AE8F9] font-500' : 'border-[transparent] text-white font-500'
                    }`}>
                    {' '}
                    <img src={StarknetLogo} className='w-[20px] h-[20px] mb-1' />
                    <span>Rewards</span>
                </span>
                {/* <span onClick={() => navigate('/pools')} className={`cursor-pointer px-2 py-1 ${selectedTab === 'pools' ? 'font-bold  bg-[#366FB7] rounded-xl' : ''}`}>
                    Pools
                </span>
                <Link to='/leaderboard?page=1' className={`cursor-pointer px-2 py-1 ${selectedTab === 'leaderboard' ? 'font-bold  bg-[#366FB7] rounded-xl' : ''}`}>
                    <span className='cursor-pointer flex items-center'>Leaderboard</span>
                </Link>
                <Link to='/charts'>
                    <span className={`cursor-pointer flex items-center px-2 py-1 ${selectedTab === 'charts' ? 'font-bold  bg-[#366FB7] rounded-xl' : ''}`}>Charts</span>
                </Link> */}
            </>
        )
    }

    function renderDesktopFooter() {
        if (isSocialDisabled) return null
        return (
            // <div className='hidden lg:flex w-full justify-center z-[0] fixed bottom-[16px]'>
            //     <div className='container '>
            <div className='flex fixed bottom-[16px] z-[10] left-[24px]'>
                <Social />
            </div>
            //     </div>
            // </div>
        )
    }

    if (!isMobile) return renderDesktopFooter()

    return (
        // <div
        //     className={`p-2 flex bg-[#0C1647] lg:hidden  fixed bottom-0 left-0 right-0 z-[10] ${className}`}
        //     style={{
        //         boxShadow: '0px 3px 7px rgba(28, 28, 34, 0.33)'
        //         // background: 'linear-gradient(118.81deg, #051A4C 0.86%, #0C2960 100%)'
        //         // background: 'linear-gradient(118.81deg, #051A4C 0.86%, #0C2960 100%)'
        //     }}>
        <div className={`${className} bg-[#0C1647] fixed bottom-0 left-0 right-0 z-[1000] flex items-center justify-between w-full`}>{renderNavigation()}</div>
        // </div>
    )
}

export default Footer
